/* Guidebook pages: sticky bar offset, lightbox, collapsible "About", set tabs (smooth scroll + highlight),
   bar shop info after the product panel, form success state, back to top, index coverflow. Added 2026-09-28. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Keep the sticky bar just below whatever is stuck at the top (announcement bar, and the header when it slides back in)
  var stuck = [document.querySelector('.announcement-bar-section'), document.querySelector('.section-header')].filter(Boolean);
  var ticking = false;
  var setTop = function () {
    ticking = false;
    var t = 0;
    stuck.forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.top < 5 && r.bottom > t) t = r.bottom;
    });
    document.documentElement.style.setProperty('--gb-sticky-top', Math.max(0, Math.round(t)) + 'px');
  };
  var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(setTop); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  stuck.forEach(function (el) { el.addEventListener('transitionend', queue); });
  setTop();

  // Card image lightbox
  document.querySelectorAll('[data-gb-zoom]').forEach(function (btn) {
    var dialog = document.getElementById(btn.getAttribute('data-gb-zoom'));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var img = dialog.querySelector('img[data-src]');
      if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
      dialog.showModal();
    });
    dialog.addEventListener('click', function () { dialog.close(); });
  });

  // Collapsible "About this deck"
  document.querySelectorAll('[data-gb-about]').forEach(function (wrap) {
    var body = wrap.querySelector('.gb-about__body');
    var btn = wrap.querySelector('.gb-about__toggle');
    if (!body || !btn) return;
    var refresh = function () {
      if (body.classList.contains('is-expanded')) return;
      wrap.classList.toggle('has-overflow', body.scrollHeight > body.clientHeight + 8);
    };
    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-expanded');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) wrap.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    window.addEventListener('resize', refresh);
    requestAnimationFrame(refresh);
  });

  // Deck page set tabs: smooth scroll on click, highlight the set in view
  var links = Array.prototype.slice.call(document.querySelectorAll('.gb-tabs a[href^="#"]'));
  var lockUntil = 0;
  var setActive = function (a) {
    links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
    if (a && a.scrollIntoView && window.innerWidth < 750) a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
  };
  if (links.length) {
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      map[id] = a;
      a.addEventListener('click', function (e) {
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var bar = a.closest('[data-gb-bar]');
        var ann = document.querySelector('.announcement-bar-section');
        var hdr = document.querySelector('.section-header');
        var offset = (bar ? bar.offsetHeight : 0) + 16;
        if (ann && getComputedStyle(ann).position === 'sticky') offset += ann.offsetHeight;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        // Scrolling up brings Dawn's header back in; leave room for it
        if (y < window.pageYOffset && hdr && getComputedStyle(hdr).position === 'sticky') y -= hdr.offsetHeight;
        setActive(a);
        lockUntil = Date.now() + 2000;
        window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
    window.addEventListener('scrollend', function () { lockUntil = 0; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (Date.now() < lockUntil) return;
        entries.forEach(function (en) {
          if (en.isIntersecting && map[en.target.id]) setActive(map[en.target.id]);
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
    }
  }

  // Price / Shop this deck in the sticky bar appear only once the product panel has scrolled away
  var panel = document.querySelector('[data-gb-panel]');
  var autoBar = document.querySelector('.gb-bar--auto');
  if (panel && autoBar) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          autoBar.classList.toggle('is-past-panel', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(panel);
    } else {
      autoBar.classList.add('is-past-panel');
    }
  }

  // "Notify me" link in the sticky bar: scroll to the form and put the cursor in the email field
  document.querySelectorAll('a[href="#gb-notify"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var box = document.getElementById('gb-notify');
      if (!box) return;
      e.preventDefault();
      box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var input = box.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 500);
    });
  });

  // Customer forms (subscribe / notify me): Shopify reloads the page with ?customer_posted=true after a post,
  // and would mark every customer form on the page as posted. Show the thank-you only on the form that was sent.
  var forms = Array.prototype.slice.call(document.querySelectorAll('form.gb-js-form'));
  forms.forEach(function (f) {
    f.addEventListener('submit', function () { try { sessionStorage.setItem('gbPostedForm', f.id); } catch (e) {} });
  });
  if (/[?&]customer_posted=true/.test(location.search)) {
    var sent = (location.hash || '').slice(1);
    try { sent = sessionStorage.getItem('gbPostedForm') || sent; sessionStorage.removeItem('gbPostedForm'); } catch (e) {}
    var f = sent && document.getElementById(sent);
    if (f && f.classList.contains('gb-js-form')) {
      var fields = f.querySelector('.gb-js-fields'), done = f.querySelector('.gb-js-done');
      if (fields) fields.hidden = true;
      if (done) done.hidden = false;
      f.scrollIntoView({ block: 'center' });
    }
  }

  // Back to top
  var top = document.querySelector('[data-gb-top]');
  if (top) {
    var onScroll = function () { top.classList.toggle('is-visible', window.scrollY > 1200); };
    window.addEventListener('scroll', onScroll, { passive: true });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    onScroll();
  }

  // Index page: flat coverflow (centre cover large, the others stacked behind on both sides)
  var flows = [];
  var initFlow = function (flow) {
    if (flow.gbFlow) { flow.gbFlow.layout(); return; }
    var stage = flow.querySelector('.gb-flow__stage');
    var items = Array.prototype.slice.call(flow.querySelectorAll('.gb-flow__item'));
    if (!stage || !items.length) return;
    var n = items.length;
    var idx = Math.floor((n - 1) / 2);
    var nameEl = flow.querySelector('[data-gb-name]');
    var byEl = flow.querySelector('[data-gb-by]');
    var cta = flow.querySelector('[data-gb-cta]');
    var posEl = flow.querySelector('[data-gb-pos]');
    var prevBtn = flow.querySelector('[data-gb-prev]');
    var nextBtn = flow.querySelector('[data-gb-next]');
    flow.classList.add('is-ready');

    var layout = function () {
      var w = items[0].offsetWidth || 280;
      var narrow = window.innerWidth < 750;
      var visible = narrow ? 3 : 5;
      var first = w * (narrow ? 0.52 : 0.56);
      var step = w * (narrow ? 0.2 : 0.24);
      items.forEach(function (it, i) {
        var d = i - idx, a = Math.abs(d), s = d < 0 ? -1 : 1;
        var x = d === 0 ? 0 : s * (first + (a - 1) * step);
        var sc = d === 0 ? 1 : Math.max(0.5, 0.84 - (a - 1) * 0.08);
        it.style.transform = 'translateX(' + x.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        it.style.zIndex = String(100 - a);
        it.classList.toggle('is-center', d === 0);
        it.classList.toggle('is-hidden', a > visible);
        var link = it.querySelector('a');
        if (link) link.tabIndex = d === 0 ? 0 : -1;
      });
      var cur = items[idx];
      if (nameEl) nameEl.textContent = cur.getAttribute('data-name');
      if (byEl) byEl.textContent = cur.getAttribute('data-by') ? 'by ' + cur.getAttribute('data-by') : '';
      if (cta) { cta.href = cur.getAttribute('data-url'); cta.setAttribute('aria-label', 'Open ' + cur.getAttribute('data-name')); }
      if (posEl) posEl.textContent = (idx + 1) + ' / ' + n;
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === n - 1;
    };
    var go = function (k) {
      k = Math.max(0, Math.min(n - 1, k));
      if (k !== idx) { idx = k; layout(); }
    };

    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(n - 1); }
    });

    // Horizontal trackpad swipe / shift + wheel (vertical wheel keeps scrolling the page)
    var acc = 0, last = 0;
    stage.addEventListener('wheel', function (e) {
      var dx = e.deltaX;
      if (!dx && e.shiftKey) dx = e.deltaY;
      if (Math.abs(dx) <= Math.abs(e.deltaY) && !e.shiftKey) return;
      e.preventDefault();
      acc += dx;
      var now = Date.now();
      if (Math.abs(acc) >= 40 && now - last > 90) { go(idx + (acc > 0 ? 1 : -1)); acc = 0; last = now; }
    }, { passive: false });

    // Drag (mouse) and swipe (touch)
    var drag = null, moved = false;
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    stage.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      if (e.target.closest('.gb-flow__nav')) return;
      drag = { x: e.clientX, y: e.clientY, idx: idx, id: e.pointerId, cap: false };
      moved = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = drag.x - e.clientX;
      if (!drag.cap) {
        if (Math.abs(dx) < 8) return;
        if (Math.abs(e.clientY - drag.y) > Math.abs(dx)) { drag = null; return; }
        drag.cap = true;
        moved = true;
        try { stage.setPointerCapture(drag.id); } catch (err) {}
        stage.classList.add('is-dragging');
      }
      go(drag.idx + Math.round(dx / (window.innerWidth < 750 ? 50 : 80)));
    });
    var end = function () {
      stage.classList.remove('is-dragging');
      drag = null;
      setTimeout(function () { moved = false; }, 0);
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    // Clicking a side cover brings it to the centre; clicking the centre cover opens the guidebook
    items.forEach(function (it, i) {
      var a = it.querySelector('a');
      if (!a) return;
      a.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); return; }
        if (i !== idx) { e.preventDefault(); go(i); }
      });
    });

    flow.gbFlow = { layout: layout };
    flows.push(flow);
    layout();
  };

  var flowEls = Array.prototype.slice.call(document.querySelectorAll('[data-gb-flow]'));
  if (flowEls.length) {
    flowEls.forEach(function (fl) { if (!fl.hidden) initFlow(fl); });
    var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-gb-tab]'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var target = null;
        tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = document.getElementById(o.getAttribute('data-gb-tab'));
          if (p) { p.hidden = !on; if (on) target = p; }
        });
        if (target) initFlow(target);
      });
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { flows.forEach(function (fl) { if (!fl.hidden) fl.gbFlow.layout(); }); }, 120);
    });
  }
})();
